import Parameter, { BoolClause } from './Parameter';
import ParameterKeyValue from './ParameterKeyValue';

export type PatientFilterFhirProp = 'subject' | 'patient';

export default class PatientFilter extends Parameter {
  private _patientId: string;
  private _fhirProp: string;

  constructor(patientId: string, fhirProp: PatientFilterFhirProp) {
    super();
    this._patientId = patientId;
    this._fhirProp = fhirProp;
  }

  get parameterKeyValue(): ParameterKeyValue {
    return new ParameterKeyValue('patient', this._patientId);
  }

  async getFSSClause(): Promise<BoolClause | null> {
    if (!this._patientId) {
      return null;
    }

    return this._getFSSPatientReferenceClause(
      `${this._fhirProp}.reference.keyword`,
      this._patientId,
    );
  }
}
